/*
 * @Author: 张玉婷
 * @Date: 2022-04-01 10:12:18
 * @LastEditTime: 2022-04-05 18:30:09
 * @LastEditors: 张玉婷
 * @Description:
 * @FilePath: \air_version_2\src\utils\cesium\wmsLayer\index.ts
 */
import * as Cesium from 'cesium';
import moment from 'moment';

/**
 * WMS服务图层
 * @param {string} url 底图对应的类型
 * @param {string} layers 图层名
 */
// 格式化时间
const timeFormatter = (issue: any) => moment(issue, 'YYYYMMDDHHmm').format('YYYY-MM-DDTHH:mm:ss.SSS');

export default class WMSLayer extends Cesium.WebMapServiceImageryProvider {
  constructor (url: string, layers: string, issue: string, callback: any | null) {
    super({
      url,
      layers,
      parameters: {
        transparent: 'true',
        format: 'image/png',
        srs: 'EPSG:4326',
        time: `${timeFormatter(issue)}Z`,
      },
    });

    //  资源加载成功回调
    this.readyPromise.then(() => setTimeout(() => callback && callback()));
  }
}
